import ResetPassword from '@/store/modules/resetPassword/constants';

export default {
  [ResetPassword.mutationTypes.setResetPasswordRequestLoading](state, loading) {
    const localState = state;

    localState.request.loading = loading;
  },
  [ResetPassword.mutationTypes.setResetTokenValidating](state, validating) {
    const localState = state;

    localState.reset.validating = validating;
  },
  [ResetPassword.mutationTypes.setResetPasswordLoading](state, loading) {
    const localState = state;

    localState.reset.loading = loading;
  },
};
